export default function getResource(label) {
    const resources = { saveToMyAccountCheckbox: 'Enregistrer dans mon compte' };

    return resources[label];
}
